import initialStateFromSchema from '~/lib/initialStateFromSchema'
import server_settings_schema from '~/schemas/server_settings_schema'
import settings_schema from '~/schemas/settings_schema'

/**
 * Local preferences PLUS the server-settings this UI actually exposes.
 *
 * The slice holds both because they share one Settings panel and one `setSettingsProperty` action. They part company on the wire: only `SERVER_SETTING_KEYS` are projected into the `server_settings` message (see ~/lib/serverSettings), and the rest never leave the browser.
 *
 * Defaults come from the CONTRACT, so the slice starts where the server starts.
 *
 * ⚠️ A server setting joins this list only when it has a UI: the client asserts every seeded value on each handshake, overriding what the session already had.
 */
export const SLICE_BACKED = ['upscale', 'output_layer']

const initialState = {
	...initialStateFromSchema(settings_schema),
	...Object.fromEntries(
		SLICE_BACKED.filter(key => key in server_settings_schema.properties).map(key => [
			key,
			server_settings_schema.properties[key].initial,
		])
	),
}

export default initialState
